/**
 * @classdesc
 * Abstrakte Wrapperklasse für Layer eines WMTS Capabilities-Dokuments.
 *
 * @class
 * @extends Object
 * @memberof gc.gis.format
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 * @param {T} capabilitiesLayer gewrappte CapabilitiesLayer-Instanz
 */
gc.gis.format.GCWmtsCapabilitiesLayer = function (capabilitiesLayer)
{
    gc.gis.GCWrappable.call(this);

    this._impl = capabilitiesLayer;

    this.identifier = undefined;
    this.title = undefined;
    this.abstract = undefined;
    this.wgs84BoundingBox = undefined;
    this.styles = [];
    this.formats = [];
    this.tileMatrixSets = [];
};
gc.gis.format.GCWmtsCapabilitiesLayer.prototype = Object.create(gc.gis.GCWrappable);

/**
 * @return {T}
 */
gc.gis.format.GCWmtsCapabilitiesLayer.prototype.getImpl = function()
{
    return this._impl;
};